module.exports = __webpack_public_path__ + "img/blue_ic_department.87b3b149.svg";